import { render, staticRenderFns } from "./registerIndex.vue?vue&type=template&id=31739e7c&scoped=true"
import script from "./registerIndex.vue?vue&type=script&lang=js"
export * from "./registerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31739e7c",
  null
  
)

export default component.exports